module.exports = __webpack_public_path__ + "img/22.efa59a21.png";